import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { applicationConfigStateSelector } from '~/selectors';

import { StoreState as ApplicationConfigStoreState } from './slice';

export const useApplicationConfig = (): ApplicationConfigStoreState => {
  return useSelector((state: StoreState) => {
    return applicationConfigStateSelector(state);
  });
};
